export const Experiments = {
  TrackingEvents: {
    donateButtonClick: 'donateButtonClick',
    shareModalOpen: 'shareModalOpen',
    shareSocialButtonClick: 'shareSocialButtonClick',
  },

  SnapchatShareOption: {
    featureKey: 'consumerairwalk_legacyfrp_shareclick_snapchat_share',
    SnapchatShareOptionExperiment: {
      experimentKey: 'consumerairwalk_legacyfrp_shareclick_snapchat_share',
      variations: {
        snapchatShareOption: 'snapchat_share_option',
        defaultShareModal: 'default_share_modal',
      },
    },
  },
};
